import { Loader } from "@progress/kendo-react-indicators";
import { ExpansionPanel, ExpansionPanelContent } from "@progress/kendo-react-layout";
import { Tooltip } from "@progress/kendo-react-tooltip";
import moment from "moment";
import React, { ComponentState, useEffect, useState } from "react";
import { Intervention } from "../../../../dataModel/clientModels";


export interface ListTreatmentInterventionProps{
    interventionData:Intervention[]
}

const ListTreatmentIntervention = (props:ListTreatmentInterventionProps) => {

    const [loading, setLoading] = useState(false);
    const [expandedObjective, setExpandedObjective] = React.useState<any>([]);
    const [isDeleteIntervention, setIsDeleteIntervention] = useState(false);
    const [selectedIntervention, setSelectedIntervention] = useState();
    const [isEditIntervention, setIsEditIntervention] = useState(false);
    let counter = 1

    const onActionObjective = React.useCallback(
        (event:any, obj:any) => {
            setExpandedObjective({ ...expandedObjective, [obj.id]: !expandedObjective[obj.id] });
            // if (event.expanded === false) {
            //     // setSelectedIntervention(obj)
            // }
        },
        [expandedObjective]
    );

    const handleCloseDeleteDialouge = () => {
        setIsDeleteIntervention(false)
    }

    const deletePlans = (obj:any) => {
        setSelectedIntervention(obj)
        setIsDeleteIntervention(true)
    }

    const handleCloseEditTreatment = (obj:any) => {
       
        setIsEditIntervention(false);
        setSelectedIntervention(obj);

    }

    const handleEditIntervention = (obj:any) => {
       
        setIsEditIntervention(true)
        setSelectedIntervention(obj)
    }

    if (loading) return <Loader />;

    return (
        <div>

            {props.interventionData.length > 0 && props.interventionData.map(interventionItem =>
                <ExpansionPanel
                    id={interventionItem.id + "rand"}
                    title={"Int #" + counter++ + ": " + interventionItem.intervention}
                    tabIndex={0}
                    key={interventionItem.id}
                    // expandIcon="k-i-plus  fa fa-plus"
                    className="main-inter"

                    // collapseIcon="k-i-minus  fa fa-minus"
                    expanded={expandedObjective[interventionItem.id]}
                    onAction={(event) => onActionObjective(event, interventionItem)}>
                    {expandedObjective[interventionItem.id] && (
                        <ExpansionPanelContent>
                            <div className="date-timeshow px-3">
                            <div className="date-timeshow px-3">
                                {interventionItem?.tpStaffTypes?.length > 0 &&
                                    <p className="mb-1">
                                        <b>Staff Type: </b>
                                        {interventionItem?.tpStaffTypes?.map((item: any, index: any) => (
                                            <span key={index}>
                                                {item.typeName}
                                                {index < interventionItem?.tpStaffTypes?.length - 1 && (
                                                    <>
                                                        <span className="symbol">,</span>
                                                        &nbsp;
                                                    </>
                                                )}
                                            </span>
                                        ))}
                                    </p>

                                }
                                {interventionItem.customStaff && <p className="mb-1"> <b>Custom Staff Types: </b> {interventionItem.customStaff}</p>}
                                <p className="mb-1"> <b>Service Type: </b>
                                    {/* {
                                        Array?.prototype?.map?.call(interventionItem?.serviceTypes, function (item) { return item?.serviceTypes; }).join(", ")} */}
                                    {
                                        interventionItem?.serviceTypes ?
                                            interventionItem.serviceTypes.map((item: any) => item.serviceType).join(", ") :
                                            ""
                                    }

                                </p>
                                {interventionItem.customServices && <p className="mb-1"> <b>Custom Services: </b> {interventionItem.customServices}</p>}
                                <p className="mb-1"> <b>Frequency: </b> {interventionItem.numFreq} {interventionItem.freq}</p>
                                <p className="mb-1"> <b>Duration:</b> {interventionItem.duration}</p>
                                <p className="mb-1"> <b>Location:</b> {
                                        interventionItem?.locations ?
                                            interventionItem.locations.map((item: any) => item.location).join(", ") :
                                            ""
                                    }</p>


                                {/* <p className="mb-1"> <b>Status: </b> {interventionItem.status}</p> */}

                            </div>


                                {/* <p className="mb-1"> <b>Status: </b> {interventionItem.status}</p> */}

                            </div>

                        </ExpansionPanelContent>
                    )}

                </ExpansionPanel>)
            }
        </div>
    )
}

export default ListTreatmentIntervention;